/** *
 * 
 * @param x : A string representing the x position of the element
 * No x should be an id of the element
 * @value void : 
 * 
 ***/

export default function scrollToX(x: string): void {
    const element = document.getElementById(x);
        if (element) {
          // 👇 Will scroll smoothly to x position
          element.scrollIntoView({ behavior: 'smooth' });
    }
}